import * as React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import StatusIcon from '@mui/icons-material/CheckCircle';
import {
    TextInput,
    FilterLiveForm,
    FilterLiveSearch,
    FilterList,
    FilterListItem,
    useTranslate,
} from 'react-admin';

const CampaignListAside = () => {
    const translate = useTranslate();
    return (
        <Card sx={{ order: -1, flex: '0 0 16em', mr: 2, mt: 4.5, alignSelf: 'flex-start' }}>
            <CardContent sx={{ pt: 1 }}>
                <FilterLiveSearch source="q" label="resources.campaign.filters.search" />
                <FilterList label="resources.campaign.fields.status" icon={<StatusIcon />}>
                    {['all', 'ongoing', 'upcoming', 'ended', 'inactive'].map(state => (
                        <FilterListItem
                            key={state}
                            label={`resources.campaign.filters.${state}`}
                            value={{ state }}
                        />
                    ))}
                </FilterList>
                <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
                    {translate('resources.campaign.filters.period')}
                </Typography>
                <FilterLiveForm validate={values =>
                    values.date_from && values.date_until && values.date_from > values.date_until
                        ? { date_until: 'resources.campaign.filters.invalid_dates' }
                        : {}
                }>
                    <TextInput source="date_from" type="date" label="resources.campaign.filters.from" parse={value => value || ''} slotProps={{ inputLabel: { shrink: true } }} fullWidth />
                    <TextInput source="date_until" type="date" label="resources.campaign.filters.until" parse={value => value || ''} slotProps={{ inputLabel: { shrink: true } }} fullWidth />
                </FilterLiveForm>
                <Typography variant="caption" color="text.secondary">
                    {translate('resources.campaign.filters.period_help')}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default CampaignListAside;
